import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ConfirmModalComponent } from '../components/confirm-modal/confirm-modal.component';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
  deleteOrphanImages: () => boolean | Observable<boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
  constructor(
    private dialog: MatDialog,
    private translator: TranslateService
  ) {}

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    if (component.canDeactivate()) {
      return true;
    }

    return this.openDialog(component);
  }

  private openDialog(component: ComponentCanDeactivate): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: this.translator.instant('create.unsaved_changes')
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        return component.deleteOrphanImages();
      }
    });

    return dialogRef.afterClosed();
  }
}
